import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';

import SalesOrderAPI from '../../api/SalesOrderAPI';
import Util from '../../util/Util';
import withRouter from '../../util/WithRouter';
import Const from '../../util/Constants';
import Display from '../../util/Display';
import ApiUiController from '../../controller/ApiUiController';

class ProbabilityList extends React.Component {

  constructor(props) {
    super(props);
    const model = reactLocalStorage.getObject(Const.Model).probability;
    this.probabilities = [];
    this.state = { ...this.state, probability: {}, popup: false, inApiCall: true };

    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Add = Util.isAllow(model.permission, Const.PermAdd);
    this.Update = Util.isAllow(model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(model.permission, Const.PermDelete);
  }

  componentDidMount() { if (this.List) { SalesOrderAPI.listProbability(this.oReceived, this.onFail); } }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  oReceived = probabilities => {
    this.probabilities = probabilities;
    this.setState({ inApiCall: false });
  };

  show = i => {
    const probability = i === -1 ? { id: 0, name: '', option_order: this.probabilities.length }
      : { ...this.probabilities[i] };
    this.setState({ ...this.state, probability: probability, popup: true });
  };
  hide = () => { this.setState({ ...this.state, popup: false }); };
  save = () => {
    if (this.state.probability.name.trim().length === 0) return;
    this.setState({ ...this.state, popup: false, inApiCall: true });
    SalesOrderAPI.saveProbability(this.state.probability, this.success, this.onFail);
  };
  success = () => {
    Util.showNotification('Successful',
      'Probability Saved successfully. Please reload page to see changes', 'success');
    SalesOrderAPI.listProbability(this.oReceived, this.onFail);
  };

  nameChange = val => this.setState({
    ...this.state,
    probability: { ...this.state.probability, name: val }
  });
  orderChange = val => this.setState({
    ...this.state,
    probability: { ...this.state.probability, option_order: val }
  });

  confirmDelete = index => {
    Util.confirmAlert('Delete', `Are you sure you want to delete to`
      + ` ${this.probabilities[index].name}`, 'Delete', 'No', () => {
        this.setState({ ...this.state, inApiCall: true });
        SalesOrderAPI.deleteProbability(this.probabilities[index].value, this.onDelete, this.onFail);
      });
  };

  onDelete = () => {
    Util.showNotification('Successful',
      'Probability Deleted successfully. Please reload page to see changes', 'success');
    SalesOrderAPI.listProbability(this.oReceived, this.onFail);
  };

  render() {
    if (!this.List) return null;
    const probabilityUI = this.probabilities.map((probability, _i) => (
      <tr key={`probability_${_i + 1}`}>
        <td>{_i + 1}</td>
        <td>{probability.name}</td>
        <td>{probability.option_order}</td>
        <td>{probability.conversion === Const.True ? Const.Yes : Const.No}</td>
        <td>{Display.ModelLabelValue('user', probability.created_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(probability.created_date)}</td>
        <td>{Display.ModelLabelValue('user', probability.updated_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(probability.updated_date)}</td>
        <td>
          {this.Update &&
            <div className="buttons success" onClick={() => this.show(_i)}>
              <FaPencilAlt /> Update
            </div>
          }
          {probability.status !== Const.AlwaysActive && this.Delete &&
            <div onClick={() => this.confirmDelete(_i)} className="buttons delete">
              <FaTrash /> Delete
            </div>
          }
        </td>
      </tr>
    ));

    return (
      <ApiUiController inApiCall={this.props.inApiCall}>
        <Modal
          show={this.state.popup} onHide={this.hide}
          size="md" aria-labelledby="contained-modal-title-vcenter" centered>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">Probability</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="row-cols-2 colmr">
                <Col xs={12}>
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Probability Name"
                    className="mr-sm-2"
                    value={this.state.probability.name}
                    onChange={event => this.nameChange(event.target.value)} />
                </Col>
              </Row>
              <Row className="row-cols-2 colmr">
                <Col xs={12}>
                  <Form.Label>Order</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Probability Order"
                    className="mr-sm-2"
                    value={this.state.probability.option_order}
                    onChange={event => this.orderChange(event.target.value)} />
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer> <Button onClick={this.save}>Save</Button></Modal.Footer>
        </Modal>

        <div className="sectionlist pt-3">

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-4 pb-3"><h3>Probabilities</h3></div>
              {this.Add &&
                <div className="col-md-8 text-right pb-3">
                  <span className="success buttons pcat" onClick={() => this.show(-1)}>
                    + Add Probability</span>
                </div>
              }
              <div className="col-md-12">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Name</th>
                      <th>Order</th>
                      <th>Conversion</th>
                      <th>Created By</th>
                      <th>Created Date</th>
                      <th>Updated By</th>
                      <th>Updated Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ApiUiController inApiCall={this.props.inApiCall}>
                      {probabilityUI}
                    </ApiUiController>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </ApiUiController>
    );
  }
}
export default withRouter(ProbabilityList);